module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._v("\n\n" + _vm._s(_vm.$teras.lang.inviatoText) + " \n\n\n "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "col s12 m3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onNew
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.inviatoButton) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 m3"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5d70d78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inviato.vue
// module id = 617
// module chunks = 2